import { FormControlLabel } from '@material-ui/core';
import { Checkbox } from '../../Checkbox';

export const CheckboxElement = ({ onChange, checked, schema }) => {
  const { properties } = schema;
  const testId = schema?.key;

  return (
    <FormControlLabel
      {...properties}
      data-testid={testId}
      control={<Checkbox checked={checked} onChange={onChange} />}
    />
  );
};
